import { combineReducers } from 'redux';
import { kycs } from './kycs/kycs';
import { offers } from './offers/offers';
import { recipient } from './recipient/recipient';
import { sender } from './sender/sender';

const fields = combineReducers({
  kycs,
  offers,
  recipient,
  sender,
});

export { fields };
